import { render, staticRenderFns } from "./MeetingSectionItem.vue?vue&type=template&id=88bd9310&scoped=true"
import script from "./MeetingSectionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingSectionItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MeetingSectionItem.vue?vue&type=style&index=0&id=88bd9310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bd9310",
  null
  
)

export default component.exports